import { logApiResponse } from "../../../util/Utility";
import BayunError from "../../../constants/BayunError";
export async function getRefreshToken(response, axiosClient) {
  if (response.status === 200) {
    try {
      const refreshResponse = await axiosClient.post("/auth/refreshToken");
      if (refreshResponse.status === 204) {
        logApiResponse("refreshResponse :", refreshResponse);
      }
    } catch (error) {
      throw BayunError.ERROR_REAUTHENTICATION_NEEDED;
    }
  }
}
